export const SET_APP_MOUNTED = 'SET_APP_MOUNTED';
